
import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

export default function CompanyIntro() {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  return (
    <section
      ref={ref}
      className="relative py-16 sm:py-24 lg:py-32 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(#00E5FF 1px, transparent 1px), linear-gradient(90deg, #00E5FF 1px, transparent 1px)',
            backgroundSize: '50px 50px',
          }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          {/* Image column */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
          >
            <div className="relative">
              <img
                src="https://eurekasanok.pl/wp-content/uploads/2018/11/spawanie.png"
                alt="EUREKA Spawalnictwo"
                className="w-full h-[280px] sm:h-[350px] lg:h-auto object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent rounded-lg"></div>
            </div>
          </motion.div>

          {/* Text column */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.2 }}
          >
            <div className="mb-4 sm:mb-6">
              <span
                className="text-[#00E5FF] text-xs sm:text-sm tracking-[0.3em] uppercase font-semibold"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                O Firmie
              </span>
              <div className="h-[2px] w-16 sm:w-20 bg-[#00E5FF] mt-3"></div>
            </div>

            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 sm:mb-8 leading-tight"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              Inżynieria
              <br />
              <span className="text-[#00E5FF]">Przyszłości</span>
            </h2>

            <div
              className="space-y-4 sm:space-y-6 text-[#C0C7CF] text-sm sm:text-base leading-relaxed"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              <p>
                Firma P.W.{' '}
                <strong className="text-white">EUREKA</strong> została założona w
                grudniu 1989r. W pierwszym okresie działalności firma zajmowała
                się handlem. Od 1991r zaczęła działalność w zakresie usług
                antykorozyjnych wysokościowych.
              </p>
              <p>
                Wykonywała usługi konserwacji słupów wysokiego napięcia,
                suwnic, chłodni kominowych w rejonie województwa śląskiego. Od
                1996 r. firma przeniosła swoją działalność na teren województwa
                podkarpackiego, zmieniając profil swojej działalności na usługi
                w zakresie{' '}
                <strong className="text-[#00E5FF]">
                  wykonawstwa konstrukcji stalowych
                </strong>
                .
              </p>
              <p className="hidden sm:block">
                Firma przystąpiła do rozbudowy pomieszczeń produkcyjnych i
                biurowych. Zakupiliśmy kilka urządzeń produkcyjnych co uczyniło
                ją bardziej konkurencyjną na rynku, w tym sprężarkę śrubową firmy
                Compaic, uniwersalną maszynę do cięcia i wykrawania Geka,
                hydrodynamiczny agregat malarski.
              </p>
            </div>

            {/* CTA */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1, delay: 0.5 }}
              className="mt-6 sm:mt-10"
            >
              <a
                href="/o-firmie"
                className="inline-flex items-center gap-3 text-[#00E5FF] font-semibold text-sm sm:text-lg group cursor-pointer whitespace-nowrap"
                style={{ fontFamily: 'Orbitron, sans-serif' }}
              >
                Poznaj naszą historię
                <i className="ri-arrow-right-line text-xl sm:text-2xl group-hover:translate-x-2 transition-transform duration-300"></i>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
